// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wfY3","newExpiryDate":"styles_newExpiryDate__3Vu3s","footer":"styles_footer__3UC4P"};